import { CreateAccountActions } from './actions';

const defaultState = {
    accountCreated: false, // true after finishing
    creatingAccount: false, // true when creating account server req begins
    // The following should be reset to undefined if being cleared from the client,
    // such that it does not override CreateAccountForm state within its getDerivedStateFromProps
    // Only set these true/false from server (Unless CreateAccountForm field errors move to redux)
    passwordErrorMessage: undefined,
    showEmailError: undefined,
    showNameError: undefined,
    showDateError: undefined,
    showSexError: undefined,
    showTermsAndPrivacyError: undefined,
    skipPasswordLoading: false,
    skipPasswordFailed: false,
};

function createAccountChangedResolver(action, state) {
    const { field, value } = action;
    return {
        ...state,
        submitted: false,
        accountCreatedFailed: false,
        formErrors: {
            ...state.formErrors,
            [`${field}`]: false,
        },
        form: {
            ...state.form,
            [`${field}`]: value,
        },
    };
}

function createAccountValidationErrorResolver(action, state) {
    const { field } = action;
    return {
        ...state,
        formErrors: {
            ...state.formErrors,
            [`${field}`]: true,
        },
    };
}

export const createAccountFormReducer = (state = defaultState, action) => {
    switch (action.type) {
        case CreateAccountActions.CLEAR_CONFIRM_EMAIL_VALIDATION_ERROR: {
            return {
                ...state,
                formErrors: {
                    ...state.formErrors,
                    confirmEmail: false,
                },
            };
        }
        case CreateAccountActions.CREATE_ACCOUNT_FORM_CHANGED: {
            return createAccountChangedResolver(action, state);
        }
        case CreateAccountActions.CREATE_ACCOUNT_VALIDATION_ERROR: {
            return createAccountValidationErrorResolver(action, state);
        }

        case CreateAccountActions.CREATE_ACCOUNT_START: {
            // the client is valid and showing no errors, so update the state
            return {
                ...state,
                submitted: true,
                creatingAccount: true,
                accountCreated: false,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_SUCCESS: {
            return {
                ...state,
                accountCreated: true,
                responseBody: action.responseBody,
                email: action.email,
                password: action.password,
                rememberMe: action.rememberMe,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_EMAIL_TAKEN: {
            return {
                ...state,
                formErrors: {
                    ...state.formErrors,
                    emailTaken: true,
                },
            };
        }
        case CreateAccountActions.CREATE_ACCOUNT_INLINE_EMAIL_CLEAR: {
            return {
                ...state,
                formErrors: {
                    ...state.formErrors,
                    emailTaken: false,
                },
            };
        }
        case CreateAccountActions.CREATE_ACCOUNT_INLINE_EMAIL_START: {
            return {
                ...state,
                inlineEmailLoading: true,
            };
        }
        case CreateAccountActions.CREATE_ACCOUNT_INLINE_EMAIL_END: {
            return {
                ...state,
                inlineEmailLoading: false,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_SHOW_PASSWORD_MODAL: {
            return {
                ...state,
                showPasswordModal: true,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_CLOSE_PASSWORD_MODAL: {
            return {
                ...state,
                showPasswordModal: false,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_FORM_SHOW_LOGIN_MODAL: {
            return {
                ...state,
                showLoginModal: true,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_FORM_CLOSE_LOGIN_MODAL: {
            return {
                ...state,
                showLoginModal: false,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_FORM_PASSWORD_STATUS_CHECK: {
            return {
                ...state,
                passwordStatusChecks: action.statusCheck,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_FORM_SHOW_INLINE_PASSWORD_STATUS_CHECK: {
            return {
                ...state,
                showInlinePasswordStatusChecks: true,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_FAILURE: {
            return {
                ...state,
                accountCreated: false,
                creatingAccount: false,
                accountCreatedFailed: true,
            };
        }

        case CreateAccountActions.CREATE_ACCOUNT_SUBMIT: {
            return {
                ...state,
                submitted: true,
            };
        }

        default:
            return state;
    }
};
